import React from 'react';
import PropTypes from 'prop-types';
import { LabelStyledTag } from './styles';

const Label = ({
  tag,
  block,
  noMargin,
  small,
  size,
  color,
  bold,
  style,
  children,
  withCursor,
  onClick,
  ...rest
}) => {
  return (
    <LabelStyledTag
      as={tag}
      inline={!block}
      noMargin={noMargin}
      bold={bold}
      type={small ? 'small' : size}
      color={color}
      withCursor={!!withCursor || !!onClick}
      style={style}
      {...rest}
    >
      {children}
    </LabelStyledTag>
  );
};
Label.propTypes = {
  tag: PropTypes.elementType,
  noMargin: PropTypes.bool,
  bold: PropTypes.bool,
  block: PropTypes.bool,
  small: PropTypes.bool,
  size: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  withCursor: PropTypes.bool,
  onClick: PropTypes.func,
};

Label.defaultProps = {
  small: false,
  tag: 'label',
  size: 'default',
  color: 'light',
};

export default React.memo(Label);
